import { criteriaDefinitions } from '../PolicyBuilder/criteriaDefinitions';
import { RULE_TYPES } from '../../../constants/returns/returnRules';

export const getReturnMultiCarrier = ({ actions }) => ({
  criteria: criteriaDefinitions({ ruleType: RULE_TYPES.RETURN_METHODS_POLICY }),
  actions: [actions],
  break_on_first_match: null,
  is_additive: null,
});
